import React, { useState, useEffect, Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import {Backdrop, CircularProgress, Grid} from "@mui/material";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MailIcon from '@mui/icons-material/Mail';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { getMenuItems } from '../StrainDashboard/StrainSIdeMenus';
import icmr from '../../../assets/icmr.png'
import foodnetlogo from '../../../assets/foodnetlogo.png'
import { Avatar, Paper, Button, Tooltip } from '@mui/material';
import { Routes, Route, useNavigate, Navigate, useParams } from "react-router-dom";
import makeStyles from '@mui/styles/makeStyles';
import LoginIcon from '@mui/icons-material/Login';
import cdac from '../../../assets/cdac.png'
import niced from '../../../assets/niced.png'
import rmrc from '../../../assets/rmrc.png'
import axios from "axios";
import {jwtDecode} from "jwt-decode";

import Swal from 'sweetalert2'
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import {toast} from "react-toastify";
import {Cookies} from "react-cookie";
import config from "../../../config.json";
const cookies = new Cookies();

const BASE_URL = config.SERVER_URL;

const drawerWidth = 260;


const useStyles = makeStyles((theme) => ({
    listItemText: {
        fontFamily: 'Rubik',
        color: 'white', // Default text color
    },
    selectedListItemText: {
        fontFamily: 'Rubik',
        color: 'white', // Text color for selected item
    },
}));

function SidebarStrain(props) {
    const navigate = useNavigate();

    const [backdropopen, setbackdropopen] = useState(false);

    const classes = useStyles();

    const { drawprops } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [selectedIndex, setSelectedIndex] = useState()

    //////console.log("menus", getMenuItems())

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };




    useEffect(() => {
        switch (window.location.pathname) {
            case "/strainrepo/straindashboard":
                setSelectedIndex(0)
                break
            case "/strainrepo/niced":
                setSelectedIndex(1)
                break
            case "/strainrepo/rmrc":
                setSelectedIndex(2)
                break;
            case "/strainrepo/genome":
                setSelectedIndex(3)
                break;
            default:
                break
        }
    }, [])

    const drawer = (
        <div>


            <List>
                {getMenuItems().map((text, index) => (
                    <ListItem key={index} onClick={() => navigate(text.menu_route)}>
                        <ListItemButton sx={{
                            '&.Mui-selected': {
                                borderRadius: 2,
                                backgroundColor: '#5a606e',
                                '&:hover': {
                                    backgroundColor: '#5a606e',
                                },
                            },
                            '&:hover': {

                            },
                        }} selected={selectedIndex === text.item_id}  >
                            <ListItemIcon sx={{ color: 'rgba(255,255,255,0.7)' }}>
                                {text.menu_icon}
                            </ListItemIcon>
                            <ListItemText primary={text.menu_name} primaryTypographyProps={{
                                style: { color: 'white', fontFamily: 'Rubik, sans-serif', fontWeight: 50 }
                            }} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>

        </div>
    );

    // Remove this const when copying and pasting into your project.
    const container = drawprops !== undefined ? () => drawprops().document.body : undefined;


    const handleLoginClick = () => {

        const t1 = sessionStorage.getItem("sessionid")

        var decodet1 = ""

        try {
            decodet1 = jwtDecode(t1)
        } catch (error) {

        }

        const name = decodet1.fname + " " + decodet1.lname
        const role = decodet1.role

        console.log("role: ", role)


        if (role === "NIRBI-LabTechnician") {
            navigate("/enterStrain")
        } else {
            Swal.fire({
                title: 'Forbidden!',
                text: 'Login as NIRBI Lab Technician to enter strain',
                icon: 'error',
                confirmButtonText: 'OK'
            })
        }
    }

    const handleLogoutClick = () => {

        Swal.fire({
            title: "Are you sure you want to logout?",
            confirmButtonText: "YES",
        }).then((result) => {
            if (result.isConfirmed) {
                setbackdropopen(true)

                axios.post(BASE_URL+"/auth/logout",
                    {}, { withCredentials: true }
                )
                    .then(response => {
                        if (response.status == 200) {

                            setbackdropopen(false)

                            toast.success("Logged Out Successfully", {
                                position: "bottom-center",
                            });

                            cookies.remove("sessionid")
                            sessionStorage.removeItem("sessionid")
                            navigate('/')
                        } else {
                            setbackdropopen(false)

                            toast.error("Something Went Wrong", {
                                position: "bottom-center",
                            });

                        }



                    })
                    .catch(error => {
                        setbackdropopen(false)
                        toast.error("Something Went Wrong", {
                            position: "bottom-center",
                        });
                    });
            }
        });

    }

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar
                position="fixed"
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                    backgroundColor: '#ffffff',
                    boxShadow: "0px 0px 0px 0px rgba(0, 0, 0, 0)",
                    height: '64px'
                }}
            >
                <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>

                    <Grid item sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ display: { sm: 'none' }, color: 'black' }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" noWrap component="div" color='black' textTransform="uppercase" sx={{ fontFamily: 'Rubik', fontWeight: 400 }}>
                            Strain Repository Dashboard For Enteric Pathogens
                        </Typography>
                        {/* <img src={cdac} alt="CDAC Logo" style={{ width: '10%', marginLeft: '1rem' }} /> */}
                    </Grid>
                    <Grid item sx={{ display: 'flex', justifyContent: 'right' }}>
                        {/* <img src={niced} alt="NICED Logo" style={{ width: '20%', marginRight: '1rem' }} /> */}
                        {/* <img src={rmrc} alt="RMRC Logo" style={{ width: '25%', marginRight: '1rem' }} /> */}
                        <Tooltip title="Enter Strain">
                            <IconButton onClick={handleLoginClick}>
                                <LoginIcon fontSize="large" sx={{ color: 'black' }} />
                            </IconButton>
                        </Tooltip>
                    </Grid>

                </Toolbar>
            </AppBar>
            <Box
                component="nav"
                sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 }, boxShadow: "0px 0px 0px 0px rgba(0, 0, 0, 0)", }}
                aria-label="mailbox folders"
            >
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Drawer
                    PaperProps={{
                        sx: {
                            color: "white",
                            boxShadow: "0px 0px 0px 0px rgba(0, 0, 0, 0)",
                            borderRight: "0px rgb(250, 251, 252)"

                        }
                    }}

                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'box', width: drawerWidth, boxShadow: "0px 0px 0px 0px rgba(0, 0, 0, 0)", borderRight: "0px rgb(250, 251, 252)" },
                        boxShadow: "0px 0px 0px 0px rgba(0, 0, 0, 0)",
                        borderRight: "0px rgb(250, 251, 252)"

                    }}
                >

                    <Paper sx={{
                        height: '100%',
                        backgroundColor: '#212631', color: 'white',
                        boxShadow: "0px 0px 0px 0px rgba(0, 0, 0, 0)",
                        borderRight: "0px rgb(250, 251, 252)", display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
                    }}>


                        <div>
                            {drawer}
                            <List>
                                <ListItem onClick={handleLogoutClick}>
                                    <ListItemButton sx={{
                                        '&.Mui-selected': {
                                            borderRadius: 2,
                                            backgroundColor: '#5a606e',
                                            '&:hover': {
                                                backgroundColor: '#5a606e',
                                            },
                                        },
                                        '&:hover': {

                                        },
                                    }} selected={false}  >
                                        <ListItemIcon sx={{ color: 'rgba(255,255,255,0.7)' }}>
                                            <ExitToAppIcon/>
                                        </ListItemIcon>
                                        <ListItemText primary={'Logout'} primaryTypographyProps={{
                                            style: { color: 'white', fontFamily: 'Rubik, sans-serif', fontWeight: 50 }
                                        }} />
                                    </ListItemButton>
                                </ListItem>
                            </List>
                        </div>
                        <div style={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'center', backgroundColor: '#212631',
                            borderRadius: '5px', marginTop: '10px', flexDirection: 'column'
                        }}>
                            <div>
                                <img src={cdac} width={'60px'} height={'60px'}></img>
                            </div>
                            <h6 style={{ color: 'white', fontSize: 14, textAlign: 'center', fontWeight: 'bold', marginTop: '3px' }}>Designed and Developed by <br></br> C-DAC, Kolkata</h6>
                        </div>
                    </Paper>
                </Drawer>
                <Drawer
                    PaperProps={{
                        sx: {
                            backgroundColor: "#212631",
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: 'white',
                            borderRight: "0px rgb(250, 251, 252)"
                        }
                    }}
                    variant="permanent"

                    sx={{
                        display: { xs: 'none', sm: 'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'box', width: drawerWidth },
                    }}
                    open
                >
                    <Paper sx={{
                        height: '100%',
                        backgroundColor: '#212631', color: 'white',
                        boxShadow: "0px 0px 0px 0px rgba(0, 0, 0, 0)",
                        borderRight: "0px rgb(250, 251, 252)", display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
                        marginBottom: 2
                    }}>
                        <div>
                            <div style={{
                                display: 'grid', alignItems: 'center',
                                justifyContent: 'center', backgroundColor: 'white',
                                borderRadius: '5px', padding: '10px', marginTop: '15px', marginLeft: '10px', marginRight: '10px'
                            }}>
                                <img src={foodnetlogo} width={'120px'} height={'70px'}></img>
                            </div>
                            {drawer}
                            <List>
                                <ListItem onClick={handleLogoutClick}>
                                    <ListItemButton sx={{
                                        '&.Mui-selected': {
                                            borderRadius: 2,
                                            backgroundColor: '#5a606e',
                                            '&:hover': {
                                                backgroundColor: '#5a606e',
                                            },
                                        },
                                        '&:hover': {

                                        },
                                    }} selected={false}  >
                                        <ListItemIcon sx={{ color: 'rgba(255,255,255,0.7)' }}>
                                            <ExitToAppIcon/>
                                        </ListItemIcon>
                                        <ListItemText primary={'Logout'} primaryTypographyProps={{
                                            style: { color: 'white', fontFamily: 'Rubik, sans-serif', fontWeight: 50 }
                                        }} />
                                    </ListItemButton>
                                </ListItem>
                            </List>

                        </div>

                        <div style={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'center', backgroundColor: '#212631',
                            borderRadius: '5px', marginTop: '10px', flexDirection: 'column'
                        }}>
                            <div>
                                <img src={cdac} width={'60px'} height={'60px'}></img>
                            </div>
                            <h6 style={{ color: 'white', fontSize: 14, textAlign: 'center', fontWeight: 'bold', marginTop: '3px' }}>Designed and Developed by <br></br> C-DAC, Kolkata</h6>
                        </div>


                    </Paper>

                </Drawer>
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={backdropopen}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </Box>
        </Box>
    );
}

SidebarStrain.propTypes = {
    /**
     * Injected by the documentation to work in an iframe.
     * Remove this when copying and pasting into your project.
     */
    drawprops: PropTypes.func,
};

export default SidebarStrain;
